import React, { createContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ChatContext = createContext({});

export const ChatProvider = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const isTutoringRoute = location.pathname.includes("tutoring");
    const scriptId = "fo9HDzr2B6O1vhXVrqNzE";
  
    const removeScript = () => {
      const script = document.getElementById(scriptId);
      if (script) script.remove();
      delete window.chatbase;
      delete window.chatbaseConfig;
    };
  
    if (isTutoringRoute) {
      const bubbleButton = document.getElementById("chatbase-bubble-button");
      if (!bubbleButton) {
        console.log("ChatContext: Bubble button missing — reinjecting script");
  
        // Remove old script if any
        removeScript();
  
        const initScript = document.createElement("script");
        initScript.id = "fo9HDzr2B6O1vhXVrqNzE";
        initScript.innerHTML = `
          window.chatbaseConfig = {
            chatbotId: 'fo9HDzr2B6O1vhXVrqNzE'
          };
          
          (function(){if(!window.chatbase||window.chatbase("getState")!=="initialized"){window.chatbase=(...arguments)=>{if(!window.chatbase.q){window.chatbase.q=[]}window.chatbase.q.push(arguments)};window.chatbase=new Proxy(window.chatbase,{get(target,prop){if(prop==="q"){return target.q}return(...args)=>target(prop,...args)}})}const onLoad=function(){const script=document.createElement("script");script.src="https://www.chatbase.co/embed.min.js";script.id="fo9HDzr2B6O1vhXVrqNzE";script.domain="www.chatbase.co";document.body.appendChild(script)};if(document.readyState==="complete"){onLoad()}else{window.addEventListener("load",onLoad)}})();
        `;
        document.head.appendChild(initScript);

      } else {
        console.log("ChatContext: Bubble button already exists — no action");
      }
    } else {
      console.log("ChatContext: Not tutoring route — removing Chatbase");
      // Optional: clean up everything
      ['chatbase-bubble-button', 'chatbase-bubble-window', 'chatbase-message-bubbles'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
      removeScript();
    }
  }, [location.pathname]);
  

  return <ChatContext.Provider value={{}}>{children}</ChatContext.Provider>;
};
